import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: auto;
  max-width: 700px;
  padding: 0 50px;

  h1 code, p code {
    color: #fabd2f;
  }

  a {
    color: #9b59b6;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: right;
`;